<div class="container-fluid cw-background manage-user manage-view" *ngIf="userToEdit">
  <mat-card class="mat-elevation-z8 my-3" id="card">
    <div class="text-left go-back d-block">
      <div class="user-create-controls-wrapper">
        <button (click)="goBack()" disableRipple mat-button class="p-0">
          <mat-icon matPreffix>arrow_back_ios</mat-icon>
          Go Back
        </button>
        <h6 class="card-title-page mb-4">{{ titleLabel() }}</h6>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row manage-user-form">
        <div class="col-4 col-sm-8 col-md-12">
          <app-dynamic-form
            #formEditUserInformation
            *ngIf="questionsEditInformation"
            [disabled]="!isEditUserInformation"
            [questions]="questionsEditInformation"
            (formSubmit)="updateUserInformation($event)"
            [questions]="questionsEditInformation"
            [editBtn]="editInformationBtn"
            [showButtons]="currentUser | applyFunctionOrValue: canUpdateInformation"
          >
          </app-dynamic-form>
        </div>
      </div>
      <div class="row manage-user-form">
        <div class="col-4 col-sm-8 col-md-12">
          <app-dynamic-form
            #formEditUserPermissions
            *ngIf="questionsEditPermission"
            [disabled]="!isEditUserPermissions"
            [questions]="questionsEditPermission"
            (hasChanged)="onChange($event)"
            (formSubmit)="updateUserPermissions($event)"
            [editBtn]="editPermissionBtn"
            [showButtons]="currentUser | applyFunctionOrValue: canUpdatePermissions"
          >
          </app-dynamic-form>
        </div>
      </div>
      <div class="row manage-user-form">
        <div class="col-4 col-sm-8 col-md-12">
          <app-dynamic-form
            #formEditUserNotification
            *ngIf="questionsEditNotification"
            [disabled]="!isEditUserNotification"
            [questions]="questionsEditNotification"
            (formSubmit)="updateUserNotification($event)"
            [editBtn]="editNotificationBtn"
            [showButtons]="currentUser | applyFunctionOrValue: canUpdateNotifications"
          >
          </app-dynamic-form>
        </div>
      </div>
      <button
        *ngIf="userToEdit | applyFunctionOrValue: canDeleteUser"
        (click)="deleteUserModal()"
        disableRipple
        mat-button
        class="delete-user"
      >
        <mat-icon matPreffix>delete</mat-icon>
        Delete user
      </button>
    </div>
    <div *ngIf="allowLinkCompanies" class="container-fluid cw-background">
      <div class="row">
        <div class="col-12">
          <mat-tab-group [@.disabled]="true">
            <mat-tab label="Companies">
              <app-data-table
                *ngIf="companiesTableConfig"
                [config]="companiesTableConfig"
                (getData)="getCompanies($event)"
                (updateData)="companiesTableService.update($event)"
              ></app-data-table>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
    <div *ngIf="allowLinkPartners" class="container-fluid cw-background">
      <div class="row">
        <div class="col-12">
          <mat-tab-group [@.disabled]="true">
            <mat-tab label="Partners">
              <app-data-table
                *ngIf="partnersTableConfig"
                [config]="partnersTableConfig"
                (getData)="getPartners($event)"
                (updateData)="partnersTableService.update($event)"
              ></app-data-table
            ></mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </mat-card>
</div>
